/**
 * @fileoverview XSS sanitization configuration options.
 * @module helpers/xssHelper
 */

/**
 * Default XSS sanitization options for the xss library.
 *
 * Configuration:
 * - whiteList: Empty object means no HTML tags are allowed
 * - stripIgnoreTag: Removes tags not in whitelist (keeps content)
 * - stripIgnoreTagBody: Completely removes script tags including content
 *
 * @type {Object}
 * @property {Object} whiteList - Allowed HTML tags and attributes (empty = none)
 * @property {boolean} stripIgnoreTag - Whether to strip non-whitelisted tags
 * @property {string[]} stripIgnoreTagBody - Tags to remove completely with content
 *
 * @example
 * import xss from 'xss';
 * const clean = xss(userInput, defaultOptionsXSS);
 */
export const defaultOptionsXSS = {
  whiteList: {},
  stripIgnoreTag: true,
  stripIgnoreTagBody: ["script"],
};
